import React, { useEffect, useMemo, useState } from 'react'
import '../../fonts/fonts.css'
import { connect, useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import { Link } from 'react-router-dom'
import ModalConfirm from '../../components/ModalConfirm/index.js'
import config from '../../config/configurator'
import { Bg, ContentLayout, Loader, FirstContainer, ContainerFirstStudent, AvatarContainer, TextFirstCSV } from './styledComponents'
import Avatar4 from '../../images/Avatar4.svg'
import moment from 'moment'
import UiDelRed from '../../images/closeRed.svg'
import UiArchive from '../../images/Archive.svg'
import SearchIcon from '../../images/search.svg'
import { deleteArchiveSaga, getArchivePlayerSaga, revertArchivePlayerSaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { deleteArchive, getArchivePlayers, revertArchivePlayer } from '../App/actions'
import {
  TablePageLayout, FilterRow, FilterSearchBox, FilterIconBtn,
  TableCard, TableScroll, StyledTable, STHead, STH, STBody, STR, STD,
  PlayerCellWrapper, InitialBubble, PlayerRowLink,
  TableActions2, TActionBtn, AgencyCellLink, NoneText,
} from '../SimuPlayers/styledComponents'

const isB2VM = process.env.REACT_APP_TYPE === 'b2vm'

const getInitials = (fullName) => {
  const parts = (fullName || '').trim().split(/\s+/)
  if (parts.length === 1) return (parts[0]?.[0] || '?').toUpperCase()
  return ((parts[0]?.[0] || '') + (parts[parts.length - 1]?.[0] || '')).toUpperCase()
}

const RevertIcon = () => (
  <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#16A34A' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
    <polyline points='1 4 1 10 7 10'/>
    <path d='M3.51 15a9 9 0 1 0 .49-3.53'/>
  </svg>
)

const SimuPlayersArchivePage = () => {
  const dispatch = useDispatch()

  const isAdmin        = useSelector(s => s.toJS().global.isAdmin)
  const loading        = useSelector(s => s.toJS().global.loading)
  const archivePlayers = useSelector(s => s.toJS().global.simuPlayers || [])
  const agencies       = useSelector(s => s.toJS().global.agencies)
  const agencytoken    = useSelector(s => s.toJS().global.agencytoken)
  const agencyid       = useSelector(s => s.toJS().global.agencyid)

  const [showModal,   setShowModal]   = useState(false)
  const [modalText,   setModalText]   = useState('')
  const [modalName,   setModalName]   = useState('')
  const [confirmText, setConfirmText] = useState('')
  const [playerId,    setPlayerId]    = useState('')
  const [modalType,   setModalType]   = useState('')
  const [searchName,  setSearchName]  = useState('')
  const [searchEmail, setSearchEmail] = useState('')

  useEffect(() => {
    dispatch(getArchivePlayers(agencytoken))
  // eslint-disable-next-line
  }, [])

  const findAgencyName = (agencyId) => {
    if (agencies == null) return ''
    if (agencyId == null) return 'Non affilié'
    const agency = isB2VM
      ? agencies.find(a => a.agencyId === agencyId)
      : agencies.find(a => a.id === agencyId)
    return agency != null ? agency.agencyname || agency.agencyName : 'Aucune agence'
  }

  const getTime = (time) => {
    if (time) {
      const h = parseInt(time / 60 / 60)
      const m = parseInt((time / 60) % 60)
      return `${h}h${m}m`
    }
    return null
  }

  const confirmDelete = (id, firstname) => {
    setShowModal(true); setPlayerId(id)
    setModalText('Attention, vous allez supprimer définitivement le compte de ')
    setModalName(firstname); setConfirmText('Supprimer'); setModalType('delete')
  }

  const confirmRevertArchive = (id, firstname) => {
    setShowModal(true); setPlayerId(id)
    setModalText('Vous allez réactiver le compte de ')
    setModalName(firstname); setConfirmText('Activer'); setModalType('revert')
  }

  const deletePlayer  = () => dispatch(deleteArchive(agencytoken, playerId, agencyid))
  const revertArchive = () => dispatch(revertArchivePlayer(playerId, agencytoken))

  const allRows = useMemo(() => {
    if (loading || !archivePlayers) return []
    return [...archivePlayers].reverse().map(player => ({
      id:                 player.studentId,
      eleve:              `${player.firstname} ${player.lastname}`,
      email:              player.email,
      agence:             findAgencyName(player.agencyId),
      agencyId:           player.agencyId,
      eval:               player.evalHours || null,
      simulationTotal:    getTime(player.playTime),
      actualDrivingTotal: player.licenceData?.actualDriving || null,
      licenceDate:        player.licenceData?.licenceDate ? moment(player.licenceData.licenceDate).format('DD/MM/YYYY') : null,
      licenceAttempts:    player.licenceData?.licenceAttempts || null,
    }))
  // eslint-disable-next-line
  }, [archivePlayers, loading])

  const rows = useMemo(() => {
    const nQ = searchName.toLowerCase().trim()
    const eQ = searchEmail.toLowerCase().trim()
    return allRows.filter(r => {
      if (nQ && !r.eleve.toLowerCase().includes(nQ))  return false
      if (eQ && !r.email.toLowerCase().includes(eQ))  return false
      return true
    })
  }, [allRows, searchName, searchEmail])

  if (loading === true || archivePlayers == null) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <Loader />
      </div>
    )
  }

  return (
    <Bg>
      <ModalConfirm
        show={showModal}
        text={modalText}
        name={modalName}
        confirm={() => { modalType === 'delete' ? deletePlayer() : revertArchive(); setShowModal(false) }}
        cancel={() => setShowModal(false)}
        confirmText={confirmText}
      />
      <ContentLayout>
        {archivePlayers.length === 0 ? (
          <FirstContainer>
            <ContainerFirstStudent>
              <AvatarContainer><img alt='avatar' src={Avatar4} /></AvatarContainer>
              <TextFirstCSV>Il n'y a pas d'élèves clôturés pour le moment</TextFirstCSV>
            </ContainerFirstStudent>
          </FirstContainer>
        ) : (
          <TablePageLayout>

            {/* ── Filter bar ── */}
            <FilterRow>
              <FilterSearchBox>
                <img src={SearchIcon} alt='' />
                <input
                  value={searchName}
                  onChange={e => setSearchName(e.target.value)}
                  placeholder='Chercher un élève'
                />
              </FilterSearchBox>
              <FilterSearchBox>
                <img src={SearchIcon} alt='' />
                <input
                  value={searchEmail}
                  onChange={e => setSearchEmail(e.target.value)}
                  placeholder='Chercher un email'
                />
              </FilterSearchBox>
              {(searchName || searchEmail) && (
                <FilterIconBtn
                  onClick={() => { setSearchName(''); setSearchEmail('') }}
                  title='Réinitialiser'
                  style={{ color: '#EF4444' }}
                >
                  ✕
                </FilterIconBtn>
              )}
              <span style={{ marginLeft: 'auto', fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280' }}>
                {rows.length} élève{rows.length !== 1 ? 's' : ''} clôturé{rows.length !== 1 ? 's' : ''}
              </span>
            </FilterRow>

            {/* ── Table ── */}
            <TableCard>
              <TableScroll>
                <StyledTable>
                  <STHead>
                    <tr>
                      <STH style={{ width: '16%' }}>Élève</STH>
                      <STH style={{ width: '16%' }}>Email</STH>
                      {isAdmin && <STH style={{ width: '13%' }}>Agence</STH>}
                      {config.features.eval && <STH style={{ width: '7%'  }}>Éval</STH>}
                      <STH style={{ width: '9%'  }}>Simulateur</STH>
                      <STH style={{ width: '10%' }}>Conduite réelle</STH>
                      <STH style={{ width: '9%'  }}>Date permis</STH>
                      <STH style={{ width: '10%' }}>Présentations</STH>
                      <STH style={{ width: '7%'  }}>Actions</STH>
                    </tr>
                  </STHead>
                  <STBody>
                    {rows.map(row => (
                      <STR key={row.id}>

                        {/* Élève */}
                        <STD>
                          <PlayerCellWrapper>
                            <InitialBubble style={{ background: 'linear-gradient(135deg, #9CA3AF 0%, #6B7280 100%)' }}>
                              {getInitials(row.eleve)}
                            </InitialBubble>
                            <PlayerRowLink to={{ pathname: `/simuplayers/edit/${row.id}`, query: { id: row.id } }}>
                              {row.eleve}
                            </PlayerRowLink>
                          </PlayerCellWrapper>
                        </STD>

                        {/* Email */}
                        <STD title={row.email}>
                          <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#6B7280' }}>{row.email}</span>
                        </STD>

                        {/* Agence */}
                        {isAdmin && (
                          <STD>
                            <AgencyCellLink
                              $inactive={row.agence === 'Aucune agence' ? 1 : 0}
                              to={{ pathname: row.agence === 'Aucune agence' ? '#' : `/agency/edit/${row.agencyId}` }}
                            >
                              {row.agence}
                            </AgencyCellLink>
                          </STD>
                        )}

                        {/* Éval */}
                        {config.features.eval && (
                          <STD>
                            {row.eval ? (
                              <Link
                                style={{ textDecoration: 'underline', color: '#374151', fontSize: '0.85rem', fontFamily: 'Poppins' }}
                                to={{ pathname: `/simuplayers/eval/${row.id}`, query: { id: row.id } }}
                              >
                                {row.eval}
                              </Link>
                            ) : <NoneText>—</NoneText>}
                          </STD>
                        )}

                        {/* Simulateur */}
                        <STD>
                          {row.simulationTotal
                            ? <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#374151', fontWeight: 500 }}>{row.simulationTotal}</span>
                            : <NoneText>—</NoneText>}
                        </STD>

                        {/* Conduite réelle */}
                        <STD>
                          {row.actualDrivingTotal
                            ? <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#374151' }}>{row.actualDrivingTotal}h</span>
                            : <NoneText>—</NoneText>}
                        </STD>

                        {/* Date permis */}
                        <STD>
                          {row.licenceDate
                            ? <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#374151' }}>{row.licenceDate}</span>
                            : <NoneText>—</NoneText>}
                        </STD>

                        {/* Présentations */}
                        <STD>
                          {row.licenceAttempts
                            ? <span style={{ fontFamily: 'Poppins', fontSize: '0.8rem', color: '#374151' }}>{row.licenceAttempts}</span>
                            : <NoneText>—</NoneText>}
                        </STD>

                        {/* Actions */}
                        <STD>
                          <TableActions2>
                            <TActionBtn
                              title='Réactiver'
                              onClick={() => confirmRevertArchive(row.id, row.eleve)}
                              style={{ borderColor: 'rgba(22,163,74,0.3)', background: '#F0FDF4' }}
                            >
                              <RevertIcon />
                            </TActionBtn>
                            <TActionBtn
                              $danger={1}
                              title='Supprimer'
                              onClick={() => confirmDelete(row.id, row.eleve)}
                            >
                              <img src={UiDelRed} alt='' style={{ width: '0.875rem', height: '0.875rem' }} />
                            </TActionBtn>
                          </TableActions2>
                        </STD>

                      </STR>
                    ))}
                  </STBody>
                </StyledTable>
              </TableScroll>
            </TableCard>
          </TablePageLayout>
        )}
      </ContentLayout>
    </Bg>
  )
}

const withConnect = connect(null, null)
const withLoader  = injectSaga({ key: 'getArchivePlayers',   saga: getArchivePlayerSaga })
const withRevert  = injectSaga({ key: 'revertArchivePlayer', saga: revertArchivePlayerSaga })
const withDelete  = injectSaga({ key: 'deleteArchive',       saga: deleteArchiveSaga })

export default compose(withLoader, withConnect, withRevert, withDelete)(SimuPlayersArchivePage)
